<header>
  <div class="container">
    <nav class="d-flex align-items-center">
      <a class="navbar-brand logo" (click)="onEvent()"><img src="/assets/img/{{ configService.configuration.logo }}" alt=""></a>
      <!-- header menu -->
      <app-header-menu></app-header-menu>
      <!--/ header menu /-->
      <div class="ml-auto d-flex align-items-center">
        <!-- language -->
        <app-language *ngIf="configService.configuration.productType !== productType.Enermedic"></app-language>
        <!--/ language /-->
        <!-- notifications -->
        <!-- (mouseenter)="notifList.updateNotifList($event);" -->
        <div class="notifications transition nav-item ml-3 d-flex align-items-center">
          <span class="icon-wrap"><i class="icon i-header-notification"></i></span>
          <div class="shared-abs-element up-arrow p-right d-none">
            <!-- bildirim api ucu tamamlandığında sonra d-none kaldırıacaktır -->
            <app-notifications-list [location]="'header-notification'"></app-notifications-list>
          </div>
        </div>
        <!--/ notifications /-->
        <!-- user area -->
        <div class="user-area transition nav-item ml-1">
          <div class="ua-cont d-flex align-items-center">
            <span class="user-name" [innerText]="usersService.userValue.Name + ' '+ usersService.userValue.Surname"></span>
            <div class="ml-3 avatar">
              <img [src]="usersService.userValue.UserAvatar" alt="">
            </div>
          </div>
          <!-- shared menu -->
          <div class="shared-abs-element up-arrow p-right shared-menu-box">
            <app-shared-menu></app-shared-menu>
          </div>
          <!--/ shared menu /-->
        </div>
        <!--/ user area /-->
      </div>
    </nav>
  </div>
</header>
